export default "__VITE_ASSET__aQEIDLEe__"